import { MessageRequestDefaultParams } from './types';

export const MESSAGE_REQUEST_DEFAULT_PARAMETERS: MessageRequestDefaultParams = {
    id: 0,
    messageType: 'fail',
};
